import { Component } from '@angular/core';

@Component({
    selector: 'fe-personal-information',
    templateUrl: './personal-information.component.html',
    styleUrls: ['./personal-information.component.scss'],
})
export class PersonalInformationComponent {}
